export function AppIconWithName() {
  return (
    <svg
      data-testid="app-icon-with-name"
      xmlns="http://www.w3.org/2000/svg"
      width="250"
      height="54"
      viewBox="0 0 790 170"
      style={{ maxHeight: '100%', width: 'auto' }}
    >
      <defs>
        <linearGradient
          id="b"
          x1="328.86"
          y1="137.91"
          x2="435.72"
          y2="36.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#00857d" />
          <stop offset=".07" stop-color="#088a82" />
          <stop offset=".17" stop-color="#1d9990" />
          <stop offset=".29" stop-color="#41b0a6" />
          <stop offset=".4" stop-color="#64c8bd" />
          <stop offset=".54" stop-color="#4bb0c0" />
          <stop offset=".85" stop-color="#1a81c6" />
          <stop offset="1" stop-color="#0870c9" />
        </linearGradient>
      </defs>
      <path
        d="M595.68,100.06c0,25.71-14.72,38.74-43.74,38.74s-43.93-13.23-43.93-39.32V14.51h-19.72v85.93c0,37.24,21.94,56.93,63.46,56.93,19.56,0,34.94-4.46,45.71-13.26,11.91-9.73,17.94-24.55,17.94-44.05V14.51h-19.72v85.55Z"
        fill="#22333b"
      />
      <polygon
        points="778.53 14.51 644.95 14.51 643.86 33.44 701.78 33.44 701.78 156.81 721.88 156.81 721.88 33.44 779.61 33.44 778.53 14.51"
        fill="#22333b"
      />
      <path
        d="M383,12.63c40.74,0,73.76,33.02,73.76,73.76,0,40.73-33.02,73.76-73.76,73.76-40.74,0-73.76-33.02-73.76-73.76,0-40.74,33.02-73.76,73.76-73.76Z"
        fill="url(#b)"
      />
      <circle cx="383" cy="86.38" r="64.91" fill="#fff" />
      <rect x="312.87" y="7.8" width="140.27" height="145.03" fill="none" />
      <circle
        cx="383"
        cy="86.38"
        r="76.09"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="4.57"
      />
      <polygon
        points="350.65 81.41 377.71 90.81 377.71 90.82 388.27 117.44 402.74 64.69 350.65 81.41"
        fill="#22333b"
      />
      <polygon
        points="455.46 34.93 454.66 34.5 453.84 34.06 452.8 33.49 444.21 28.84 438.99 19.2 438.54 18.38 431.72 5.78 431.72 5.78 424.89 18.38 424.45 19.2 419.23 28.84 410.12 33.77 409.59 34.05 408.78 34.5 407.91 34.97 396.17 41.32 407.63 47.53 408.78 48.15 409.6 48.59 419.23 53.81 423.64 61.96 424.45 63.45 424.89 64.26 425.27 64.96 431.72 76.87 437.97 65.32 438.54 64.26 438.98 63.45 439.56 62.38 444.2 53.81 452.8 49.15 453.84 48.59 454.66 48.15 455.88 47.49 467.26 41.32 455.46 34.93"
        fill="#22333b"
        stroke="#fff"
        stroke-linejoin="round"
        stroke-width="7.26"
      />
      <path
        d="M75.8,76.24c-14.6-2.77-25.61-5.75-32.72-8.85-6.22-2.78-9.24-7.2-9.24-13.51,0-12.87,14-21.19,35.67-21.19,17.63,0,35.39,5.14,49.99,14.46l4.08,2.58-.04-18.2v-3.2l-1.28-.72c-14.81-8.33-33.63-13.11-51.63-13.11-39.14,0-56.67,20.53-56.67,40.87,0,11.8,4.93,20.51,14.64,25.89,9.04,5,22.01,9.08,38.55,12.12,17.22,3.25,28.35,6.42,34.06,9.7,5.45,2.97,8.1,7.36,8.1,13.41,0,13.88-14.17,22.51-36.99,22.51-19.36,0-39.92-5.87-57.9-16.54l-4.03-2.55v2.17s0,0,0,0v19.02l1.28.72c18.22,10.19,38.56,15.36,60.46,15.36,42.06,0,57.04-21.5,57.04-41.62,0-24.86-19.57-33.24-53.39-39.32Z"
        fill="#22333b"
      />
      <path
        d="M274.42,120.99h0s-.1.08-.1.08c-16.28,11.98-31.82,17.57-48.91,17.57-32.86,0-54.1-20.65-54.1-52.6,0-14.93,5.26-28.38,14.8-37.88,9.92-9.87,23.7-15.09,39.86-15.09,20.66,0,35.46,8.63,48.37,17.96l.08.06h0s4.08,2.98,4.08,2.98v-2.56s0,0,0,0v-18.81l-1.02-.75c-10.54-7.77-27.96-17.04-51.13-17.04-43.99,0-74.72,29.33-74.72,71.34s28.66,70.58,73.03,70.58c25.87,0,44.19-10.43,52.8-16.65l1.04-.75v-18.83h0v-2.57s-4.07,2.98-4.07,2.98Z"
        fill="#22333b"
      />
    </svg>
  );
}
